import { Link } from "react-router-dom";
import { Wrench } from "lucide-react";

import { cn } from "@/lib/cn";
import type { ToolOut } from "@/api/types";

interface ToolChipProps {
  tool: ToolOut;
  className?: string;
}

const KIND_LABEL: Record<ToolOut["kind"], string> = {
  skill: "skill",
  script: "script",
  agent: "agent",
  template: "template",
  service: "сервис",
  other: "tool",
};

export function ToolChip({ tool, className }: ToolChipProps) {
  return (
    <Link
      to={`/tools?q=${encodeURIComponent(tool.slug)}`}
      aria-label={`Инструмент ${tool.name} (${KIND_LABEL[tool.kind]})`}
      className={cn(
        "inline-flex min-h-touch items-center gap-1.5 rounded-full bg-sbg px-3 py-1 text-sm",
        "hover:bg-sbg/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent",
        className,
      )}
    >
      <Wrench className="h-3.5 w-3.5 text-hint" aria-hidden="true" />
      <span className="font-medium">{tool.name}</span>
      <span className="text-xs uppercase text-hint">{KIND_LABEL[tool.kind]}</span>
    </Link>
  );
}
